import { render } from "./insertImage.vue?vue&type=template&id=a890745c&scoped=true"
import script from "./insertImage.vue?vue&type=script&lang=js"
export * from "./insertImage.vue?vue&type=script&lang=js"

import "./insertImage.vue?vue&type=style&index=0&id=a890745c&lang=scss&scoped=true"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a890745c"]])

export default __exports__